import React from 'react'
import { Grid, Typography, Theme } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import { useUserSession } from '@utils/useUserSession'
import {
  useProductFromQueryParam,
  getProductBasedRequestMailId,
} from '../../ProductsConfiguration'

const useStyle = makeStyles((theme: Theme) => {
  return {
    infoText: {
      fontSize: theme.typography.pxToRem(12),
    },
  }
})

const FeasibilityMessage = () => {
  const { userSession } = useUserSession()
  const countryCode = userSession.country
  const product = useProductFromQueryParam()
  const classes = useStyle()
  const mailId = getProductBasedRequestMailId(product, countryCode)
  return (
    <Grid container style={{ marginTop: '24px' }}>
      <Typography
        component="span"
        variant="body1"
        data-scrub
        className={classes.infoText}
      >
        <FormattedMessage
          id="PC_SEND_FEASIBLITY_AND_QUOTATION_MSG"
          defaultMessage="Send your feasibility and quotation request for modifications not listed to"
        />
      </Typography>
      &nbsp;
      <Typography
        component="span"
        variant="body1"
        data-scrub
        className={classes.infoText}
      >
        <a href={`mailto:${mailId}`}>{mailId}</a>
      </Typography>
      {'.'}
    </Grid>
  )
}

export default FeasibilityMessage
